import { render, staticRenderFns } from "./PageShop.vue?vue&type=template&id=e1bac164"
import script from "./PageShop.vue?vue&type=script&lang=js"
export * from "./PageShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports